import ApiClientFactory from '../../api/client-factory';
import { CustomersApiService } from './service';

const service = new CustomersApiService(ApiClientFactory());

export function CustomersApiServiceFactory(): typeof service {
  return service;
}
